module.exports = __webpack_public_path__ + "static/media/Doors.426a9b24.png";